// extracted by mini-css-extract-plugin
export default {"logoContainer":"EmailInactivation_logoContainer__uE-k4","logo":"EmailInactivation_logo__YDRO7"};